import React from "react";
import Navbar from "../components/Navbar";
import ServiceHeader from "../components/ServicesComponents/ServiceHeader";
import CoatingDivision from "../components/ServicesComponents/CoatingDivision";
import Solar from "../components/ServicesComponents/Solar";
import FortifiedRoof from "../components/ServicesComponents/FortifiedRoof";
import NCJUA from "../components/ServicesComponents/NCJUA";

const Services: React.FC = () => {
  return (
    <div className="">
      <Navbar />
      <div id="ServiceHeader">
        <ServiceHeader />
      </div>
      <div id="NCJUA">
        <NCJUA />
      </div>
      <div id="CoatingDivision">
        <CoatingDivision />
      </div>
      <div id="Solar">
        <Solar />
      </div>
      <div id="FortifiedRoof">
        <FortifiedRoof />
      </div>
    </div>
  );
};

export default Services;
